import { handleActions } from 'redux-actions';
import update from 'react-addons-update';
import * as actionTypes from './actionTypes';

const initialState = {
  availableYears: [],
  info: {},
  isLoading: {},
  error: {},
};

const clearErrorAndIsLoading = (state, key) => update(state, {
  error: {
    [key]: { $set: null },
  },
  isLoading: {
    [key]: { $set: false },
  },
});

const clearAllErrorAndIsLoading = (state) => update(state, {
  error: { $set: {} },
  isLoading: { $set: {} },
});

const fetchAvailableYearsRequest = (state) => update(state, {
  error: {
    [actionTypes.FETCH_AVAILABLE_YEARS_REQUEST]: { $set: null },
  },
  isLoading: {
    [actionTypes.FETCH_AVAILABLE_YEARS_REQUEST]: { $set: true },
  },
});

const fetchAvailableYearsSuccess = (state, action) => update(state, {
  availableYears: { $set: action.payload.years },
  isLoading: {
    [actionTypes.FETCH_AVAILABLE_YEARS_REQUEST]: { $set: false },
  },
});

const fetchAvailableYearsFailure = (state, action) => update(state, {
  error: {
    [actionTypes.FETCH_AVAILABLE_YEARS_REQUEST]: { $set: action.payload },
  },
  isLoading: {
    [actionTypes.FETCH_AVAILABLE_YEARS_REQUEST]: { $set: false },
  },
});

const fetchInfoRequest = (state, action) => update(state, {
  error: {
    [action.payload.year]: { $set: null },
  },
  isLoading: {
    [action.payload.year]: { $set: true },
  },
});

const fetchInfoSuccess = (state, action) => update(state, {
  info: {
    [action.payload.year]: { $set: action.payload.info },
  },
  isLoading: {
    [action.payload.year]: { $set: false },
  },
});

const fetchInfoFailure = (state, action) => update(state, {
  error: {
    [action.payload.year]: { $set: action.payload },
  },
  isLoading: {
    [action.payload.year]: { $set: false },
  },
});

export default handleActions({
  [actionTypes.CLEAR_ERROR_AND_ISLOADING]: clearErrorAndIsLoading,
  [actionTypes.CLEAR_ALL_ERROR_AND_ISLOADING]: clearAllErrorAndIsLoading,

  [actionTypes.FETCH_AVAILABLE_YEARS_REQUEST]: fetchAvailableYearsRequest,
  [actionTypes.FETCH_AVAILABLE_YEARS_SUCCESS]: fetchAvailableYearsSuccess,
  [actionTypes.FETCH_AVAILABLE_YEARS_FAILURE]: fetchAvailableYearsFailure,

  [actionTypes.FETCH_INFO_REQUEST]: fetchInfoRequest,
  [actionTypes.FETCH_INFO_SUCCESS]: fetchInfoSuccess,
  [actionTypes.FETCH_INFO_FAILURE]: fetchInfoFailure,
}, initialState);
